import { render, staticRenderFns } from "./IntroductionPage.vue?vue&type=template&id=738f65f4&scoped=true&"
import script from "./IntroductionPage.vue?vue&type=script&lang=js&"
export * from "./IntroductionPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionPage.vue?vue&type=style&index=0&id=738f65f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738f65f4",
  null
  
)

export default component.exports